<div class="despacho-container">
    <div *ngIf="loading" class="loading-overlay">
        <div class="spinner"></div>
        <p>Cargando datos...</p>
    </div>

    <div *ngIf="error" class="error-message">
        <p>{{ error }}</p>
        <button (click)="closeError()" class="btn-close">&times;</button>
    </div>

    <div class="header-controls">
        <div class="left-controls">
            <div class="year-control">
                <label for="year">A&ntilde;o</label>
                <div class="year-input-wrapper">
                    <input type="text" id="year" [value]="year" readonly />
                    <div class="year-buttons">
                        <button (click)="changeYear(1)" [disabled]="loading || reportLoading" class="btn-arrow">&#9650;</button>
                        <button (click)="changeYear(-1)" [disabled]="loading || reportLoading" class="btn-arrow">&#9660;</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="action-buttons">
            <button class="btn-action report"
                    type="button"
                    [disabled]="loading || reportLoading"
                    [matMenuTriggerFor]="reportMenu">
                <mat-icon class="action-icon" aria-hidden="true">download</mat-icon>
                <span>Generar Informe</span>
            </button>
            <mat-menu #reportMenu="matMenu" xPosition="before">
                <button mat-menu-item
                        type="button"
                        [disabled]="reportLoading || !selectedDespachoId"
                        (click)="generarInformeWord()">
                    Seleccionado
                </button>
                <button mat-menu-item
                        type="button"
                        [disabled]="reportLoading || !selectedPersonaId"
                        (click)="abrirInformeRango()">
                    Varios (entre fechas)
                </button>
            </mat-menu>
        </div>
    </div>

    <div class="tabs">
        <div class="tab active">Consulta</div>
    </div>

    <div class="table-container">
        <table class="personas-table">
            <colgroup>
                <col class="nombre-column">
                <col *ngFor="let month of months" class="month-column">
            </colgroup>
            <thead>
                <tr>
                    <th class="nombre-column">Persona</th>
                    <th *ngFor="let month of months">{{ month }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let persona of personas"
                    [ngClass]="{'selected': selectedPersonaId === persona.id}"
                    (click)="selectPersona(persona)">
                    <td class="nombre-cell">{{ persona.nombre }}</td>
                    <td *ngFor="let month of months"
                        [ngClass]="{'has-despachos': persona.visitas[month]?.length}">
                        <button *ngFor="let despacho of persona.visitas[month]"
                                type="button"
                                class="fecha-button"
                                [class.visita-realizada]="despacho.realizada"
                                [class.selected-date]="selectedDespachoId === despacho.id"
                                [title]="despacho.fechaCompleta"
                                (click)="selectDespacho(persona, despacho, $event)">
                            {{ despacho.fechaVisita }}
                        </button>
                    </td>
                </tr>
                <tr *ngIf="personas.length === 0 && !loading">
                    <td [attr.colspan]="months.length + 1" class="no-data">No hay datos disponibles para el a&ntilde;o seleccionado</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="footer">
        <div class="footer-columns">
            <div class="visitas-container">
                <div class="visitas-header">Visitas:</div>
                <div class="visitas-content">
                    <div class="visita-type">
                        <span>Realizada</span>
                        <div class="visita-indicator realizada"></div>
                    </div>
                    <div class="visita-type">
                        <span>Pendiente</span>
                        <div class="visita-indicator pendiente"></div>
                    </div>
                </div>
            </div>

            <div class="details-container">
                <div class="fechaReunion-row">
                    <label for="fechaReunion">Fecha Reuni&oacute;n:</label>
                    <input type="text" id="fechaReunion"
                           [(ngModel)]="fechaReunion"
                           (change)="updateFechaReunion()"
                           [disabled]="!selectedDespachoId" />
                    <button (click)="fechaReunion = ''"
                            [disabled]="!selectedDespachoId || !fechaReunion">
                        &times;
                    </button>
                </div>

                <div class="comentarios-container">
                    <textarea id="comentarios"
                              [(ngModel)]="comentarios"
                              (change)="updateComentarios()"
                              [disabled]="!selectedDespachoId"
                              rows="8"
                              placeholder="Comentarios..."></textarea>
                </div>
            </div>
        </div>
    </div>
</div>
